<template>
  <div id="createContainer">
    <v-overlay :value="isLoading" color="#565656">
      <v-progress-circular indeterminate size="64" color="565656"></v-progress-circular>
    </v-overlay>
    <div class="createTitle">{{this.isUpdateMode ? '수정' : '생성'}}</div>
    <div v-if="this.siteId !== -1" style="margin-top: 10px">사업지 ID: {{this.siteId}}</div>
    <div class="dialogContainer">
      <div class="addressSearch">
        <div class="subTitle">주소 검색하기</div>
        <div class="searchButton" @click="onSearch">
          <img src="../../../../public/icons/search.svg">
        </div>
        <div v-if="this.kakaoAddressInfo.requestedAddress"
             style="margin-left: 10px;"
        >requestedAddress: {{this.kakaoAddressInfo.requestedAddress}}</div>
      </div>
      <address-info-component/>
      <div class="infoContainer">
        <div>
          <div class="item">
            <div>사이트명</div>
            <input
                v-model="siteName"
                type="text"
                class="textInput"
                placeholder=""
                @change="updateValidation"
            >
          </div>
          <div class="item">
            <div>시행사/신탁사</div>
            <input
                v-model="developer"
                type="text"
                class="textInput"
                placeholder="공백없이 입력해주세요."
                @change="updateValidation"
            >
          </div>
          <div class="item">
            <div>사업형태</div>
            <v-select
                v-model="businessTypeCode"
                :items="businessTypeCodeList"
                label=""
                no-data-text="사업형태 선택"
                dense
                height="50"
                outlined
                hide-details="auto"
                class="comboBox"
                color="black"
                item-text="name"
                item-value="value"
                item-color="#FAFAFA"
            ></v-select>
          </div>
          <div class="item">
            <div>건물형태</div>
            <v-select
                v-model="buildingTypeCode"
                :items="buildingTypeCodeList"
                label=""
                no-data-text="건물형태 선택"
                dense
                height="50"
                outlined
                hide-details="auto"
                class="comboBox"
                item-text="name"
                item-value="value"
                color="black"
                item-color="#FAFAFA"
            ></v-select>
          </div>
        </div>
        <div>
          <div class="item">
            <div>사업단계</div>
            <v-select
                v-model="statusCode"
                :items="statusCodeList"
                label=""
                no-data-text="사업단계 선택"
                dense
                height="50"
                outlined
                hide-details="auto"
                class="comboBox"
                item-text="name"
                color="black"
                item-value="value"
                item-color="#FAFAFA"
            ></v-select>
          </div>
          <div class="item">
            <div>담당자</div>
            <input
                v-model="responsible"
                type="text"
                class="textInput"
                placeholder="공백없이 입력해주세요."
                @change="updateValidation"
            >
          </div>
          <div class="item">
            <div>등록일</div>
            <input
                v-model="registeredDt"
                type="text"
                class="textInput"
                placeholder="yyyy-MM-dd 형태로 입력하세요."
                @change="updateValidation"
            >
          </div>
        </div>
      </div>
      <div class="infoContainer2">
        <div class="item">
          <div>전체세대수</div>
          <input
                v-model="totalHouseholds"
                type="text"
                class="textInput inputRight"
                placeholder="0"
            >
        </div>
        <div class="item">
          <div>일반세대수</div>
          <input
                v-model="households"
                type="text"
                class="textInput inputRight"
                placeholder="0"
            >
        </div>
        <div class="item">
          <div>분양가 (천원)</div>
          <input
                v-model="parcelPrice"
                type="text"
                class="textInput inputRight"
                placeholder="0"
            >
        </div>
      </div>
    </div>
    <div v-if="this.isUpdateMode" class="buttonContainer">
      <div class="deleteButton" @click="setShowHyundaiLoginFailedPopup(true)">삭제</div>
      <div class="clearButton" @click="onClear">초기화</div>
      <div class="createButton" @click="onUpdate">수정</div>

    </div>
    <div v-else class="buttonContainer">
      <div class="clearButton" @click="onClear">초기화</div>
      <div class="createButton" @click="onCreate">생성</div>
    </div>

    <address-map-component
        v-if="this.showMap"
    />
    <popup-dialog-component
        v-if="showHyundaiLoginFailedPopup"
        title="사업지 정보를 삭제하시겠습니까?"
        caption="삭제된 내용은 복구할 수 없고, 재등록해야합니다.<br>삭제하시겠습니까?"
        mode="delete"
        :site-id="this.siteId"
    ></popup-dialog-component>
  </div>

</template>

<script>
import AddressInfoComponent from "./AddressInfoComponent";
import AddressMapComponent from "./addressMapComponent";
import {mapMutations, mapState} from "vuex";
import PopupDialogComponent from "./PopupDialogComponent";
import {api} from "../../../mixins/api";

export default {
  name: "CreateBusinessLocationComponent",
  components: {PopupDialogComponent, AddressMapComponent, AddressInfoComponent},
  computed: {
    ...mapState(["showMap", "kakaoAddressInfo", "showHyundaiLoginFailedPopup", "businessSiteInputInfo"])
  },
  props: {
    siteId: {
      type: Number,
      default() { return -1; }
    },
    isUpdateMode: {
      type: Boolean,
      default() { return false; }
    }
  },
  async mounted() {
    if (this.siteId !== -1 && this.isUpdateMode) {
      let response = await api.methods.getHdecBusinessSite(this.siteId);
      if (response === undefined) {
        alert('사업지가 없습니다.');
        return;
      }

      this.setKakaoAddressInfo({
        requestedAddress: response.requestedAddress,
        latY: response.latY,
        lonX: response.lonX,
        addressBjd: response.addressBjd,
        addressRoad: response.addressRoad,
        sd: response.sd,
        sgg: response.sgg,
        emd: response.emd,
        bunjiMountain: response.bunjiMountain,
        bunjiMain: response.bunjiMain,
        bunjiSub: response.bunjiSub,
        bjdCode: response.bjdCode
      });

      this.siteId = response.siteId;
      this.siteName = response.siteName;
      this.developer = response.developer;
      this.businessTypeCode = response.businessTypeCode;
      this.buildingTypeCode = response.buildingTypeCode;
      this.totalHouseholds = response.totalHouseholds;
      this.households = response.households;
      this.parcelPrice = response.parcelPrice;
      this.statusCode = response.statusCode;
      this.responsible = response.responsible;
      this.registeredDt = response.registeredDt.split('T')[0];

      this.updateValidation();
    }
  },
  data() {
    return {
      businessTypeCodeList: [
        {"name": "자체", "value": 10},
        {"name": "민간도급", "value": 20},
        {"name": "도시정비", "value": 30},
        {"name": "공공", "value": 40},
        {"name": "지역조합", "value": 50}
      ],
      buildingTypeCodeList: [
        {"name": "아파트", "value": 10},
        {"name": "주상복합", "value": 20},
        {"name": "오피스텔", "value": 30},
        {"name": "타운하우스", "value": 40},
      ],
      statusCodeList: [
        {"name": "조회기록", "value": 0},
        {"name": "수주전", "value": 10},
        {"name": "기수주", "value": 20},
        {"name": "분양예정", "value": 30},
        {"name": "분양완료", "value": 40},
        {"name": "준공 및 예정", "value": 50},
      ],
      siteName: null,
      developer: null,
      businessTypeCode: 10,
      buildingTypeCode: 10,
      totalHouseholds: null,
      households: null,
      parcelPrice: null,
      statusCode: 0,
      responsible: null,
      registeredDt: null,
      isValid: false,
      isLoading: false,
    }
  },
  methods: {
    ...mapMutations(["setShowMap", "setKakaoAddressInfo", "setShowHyundaiLoginFailedPopup", "setBusinessSiteInputInfo"]),
    updateValidation() {
      if (!this.siteName) {
        this.isValid = false;
        return "사업지";
      }

      if (!this.developer) {
        this.isValid = false;
        return "시행사/신탁사";
      }

      if (!this.responsible) {
        this.isValid = false;
        return "담당자";
      }

      function isValidDate(dateString) {
        var regEx = /^\d{4}-\d{2}-\d{2}$/;
        if(!dateString.match(regEx)) return false;  // Invalid format
        var d = new Date(dateString);
        var dNum = d.getTime();
        if(!dNum && dNum !== 0) return false; // NaN value, Invalid date
        return d.toISOString().slice(0,10) === dateString;
      }
      if (!this.registeredDt || isValidDate(this.registeredDt) === false) {
        this.isValid = false;
        return "등록일";
      }

      this.isValid = true;
      return true;
    },
    onClear() {
      this.addressList = [];
      this.siteName = null;
      this.developer = null;
      this.businessTypeCode = 10;
      this.buildingTypeCode = 10;
      this.totalHouseholds = null;
      this.households = null;
      this.parcelPrice = null;
      this.statusCode = 0;
      this.responsible = null;
      this.registeredDt = null;
      this.setKakaoAddressInfo({});
      this.setBusinessSiteInputInfo({});
    },
    saveBusinessSiteInputInfo() {
      this.setBusinessSiteInputInfo({
        siteName: this.siteName,
        developer: this.developer,
        businessTypeCode: this.businessTypeCode,
        buildingTypeCode: this.buildingTypeCode,
        totalHouseholds: this.totalHouseholds,
        households: this.households,
        parcelPrice: this.parcelPrice,
        statusCode: this.statusCode,
        responsible: this.responsible,
        registeredDt: this.registeredDt,
      })
    },
    async onSearch() {
      this.setShowMap(true);
    },
    async onCreate() {
      this.saveBusinessSiteInputInfo();
      let model = {
        ...this.businessSiteInputInfo,
        ...this.kakaoAddressInfo
      }

      let validationResult = this.updateValidation();
      if (validationResult !== true) {
        alert(`${validationResult} 정보를 확인해주세요`);
        return;
      }

      this.isLoading = true;
      let response = await api.methods.createHdecBusinessSite(model);
      this.isLoading = false;
      if (response) {
        this.$router.replace('/hyundai');
      }
    },
    async onUpdate() {
      this.saveBusinessSiteInputInfo();
      let model = {
        ...this.businessSiteInputInfo,
        ...this.kakaoAddressInfo
      }

      let validationResult = this.updateValidation();
      if (validationResult !== true) {
        alert(`${validationResult} 정보를 확인해주세요`);
        return;
      }

      this.isLoading = true;
      let response = await api.methods.updateHdecBusinessSite(this.siteId, model);
      if (response) {
        // do nothing
      }
      this.isLoading = false;
    }
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: #E9EAEC;
}

#createContainer {
  width: 1100px;
  height: 680px;
  background: #FFFFFF;
  padding: 60px 80px;
  box-shadow: 0px 4px 40px rgba(51, 51, 51, 0.1);
  border-radius: 30px;
}

.textInput::placeholder {
  color: #A5A5A5;
}

.inputRight {
  text-align: end;
}

.createTitle {
  font-size: 24px;
  line-height: 24px;
  letter-spacing: -0.6px;
  color: #333333;
}

.dialogContainer {
  margin-top:40px;
  padding-right: 44px;
  width: 998px;
  height: 452px;
  overflow-y: auto;
  overflow-x: hidden;
}

.subTitle {
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #333333;
}

.comboBox {
  background: #FAFAFA;
  box-sizing: border-box;
  border-radius: 8px;
  max-width: 286px;
}

.addressSearch {
  display: flex;
  align-items: center;
}


.item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 401px;
  height: 50px;
  margin-bottom: 16px;
}

.item > div:nth-child(1) {
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #333333;
}

.searchButton {
  margin-left: 12px;
  background: #333333;
  box-shadow: 2px 2px 4px rgba(0, 0, 0, 0.1);
  border-radius: 8px;
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.searchButton > img {

}

.searchButton:hover {
  cursor: pointer;
}

.textInput {
  display: flex;
  align-items: center;
  padding: 0 20px;
  width: 286px;
  height: 50px;
  background: #FAFAFA;
  border: 1px solid #E9EAEC;
  box-sizing: border-box;
  border-radius: 8px;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #A5A5A5;
}

.infoContainer {
  display: flex;
  justify-content: space-between;
  /*width: 940px;*/
  height: 248px;
  width: 937px;
}

.infoContainer2 {
  margin-top: 36px;

}

.buttonContainer {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}

.clearButton {
  width: 151px;
  height: 50px;
  background: #FFFFFF;
  border: 1px solid #333333;
  box-sizing: border-box;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.474667px;
  color: #333333;
}

.createButton {
  width: 151px;
  height: 50px;
  background: #333333;
  box-sizing: border-box;
  border-radius: 100px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
  line-height: 18px;
  letter-spacing: -0.474667px;
  color: #FFFFFF;
  margin-left: 16px;
}

.deleteButton {
  background: #FFFFFF;
  border-radius: 100px;
  font-size: 16px;
  line-height: 16px;
  letter-spacing: -0.6px;
  color: #565656;
  margin-right: 60px;
}

.clearButton:hover, .createButton:hover, .deleteButton:hover {
  cursor: pointer;
}





</style>
